import Phaser from 'phaser';
import { PreloadScene } from './scenes/PreloadScene';
import { BriefingScene } from './scenes/BriefingScene';
import { GameScene } from './scenes/GameScene';
import { MissionCompleteScene } from './scenes/MissionCompleteScene';
import { MissionFailScene } from './scenes/MissionFailScene';
import { MemorialScene } from './scenes/MemorialScene';
import { MapEditorScene } from './scenes/MapEditorScene';
import { HUD } from './ui/HUD';

const config = {
  type: Phaser.WEBGL,
  width: 800,
  height: 600,
  backgroundColor: '#1a1a2e',
  parent: 'game-container',
  resolution: window.devicePixelRatio || 1,
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [PreloadScene, BriefingScene, GameScene, MissionCompleteScene, MissionFailScene, MemorialScene, MapEditorScene, HUD],
} satisfies Phaser.Types.Core.GameConfig & { resolution: number };

new Phaser.Game(config);
